export const PARENT_PATH = '/roles';
